export const FILTER_DATE_RANGE_FOR_BILLING_HISTORY = [
  {
    label: 'Last 3 months',
    value: 3,
  },
  {
    label: 'Last 6 months',
    value: 6,
  },
  {
    label: 'Year-to-date',
    value: 12,
  },
  {
    label: 'Last 36 months',
    value: 36,
  },
  { label: 'Custom', value: 0 },
];
export const FILTER_DATE_RANGE_FOR_PAYMENT_HISTORY = [
  {
    label: 'Last 3 months',
    value: 3,
  },
  {
    label: 'Last 6 months',
    value: 6,
  },
  {
    label: 'Year-to-date',
    value: 12,
  },
  {
    label: 'Last 18 months',
    value: 18,
  },
  { label: 'Custom', value: 0 },
];
export const FILTER_DATE_RANGE_FOR_GOV_PAYMENT_HISTORY_TMG = [
  {
    label: 'Last 3 months',
    value: 3,
  },
  {
    label: 'Last 6 months',
    value: 6,
  },
  {
    label: 'Year-to-date',
    value: 12,
  },
  {
    label: 'Last 24 months',
    value: 24,
  },
  { label: 'Custom', value: 0 },
];
export const FILTER_DATE_RANGE_FOR_GOV_BILLING_HISTORY_TMG = [
  {
    label: 'Last 3 months',
    value: 3,
  },
  {
    label: 'Last 6 months',
    value: 6,
  },
  {
    label: 'Year-to-date',
    value: 12,
  },
  {
    label: 'Last 24 months',
    value: 24,
  },
  { label: 'Custom', value: 0 },
];

export const FILTER_DATE_RANGE_FOR_GOV_BILLING_HISTORY_VMS = [
  {
    label: 'Last 3 months',
    value: 3,
  },
  {
    label: 'Last 6 months',
    value: 6,
  },
  {
    label: 'Last 12 months',
    value: 12,
  },
  {
    label: 'Last 18 months',
    value: 18,
  },
  { label: 'Custom', value: 0 },
];
export const DEFAULT_DATE_RANGE_FOR_BILLING_HISTORY_IN_MONTHS = 12;
export const MAX_DATE_RANGE_FOR_BILLING_HISTORY_IN_MONTHS = 36;
export const MAX_DATE_RANGE_FOR_GOV_TMG_BILLING_HISTORY_IN_MONTHS = 24;
export const DEFAULT_DATE_RANGE_FOR_PAYMENT_HISTORY_IN_MONTHS = 18;
export const DEFAULT_DATE_RANGE_FOR_GOV_TMG_PAYMENT_HISTORY_IN_MONTHS = 24;
export const MAX_DATE_RANGE_FOR_GOV_VMS_BILLING_HISTORY_IN_MONTHS = 18;
export const FILTER_DATE_RANGE_LIST_FOR_BILLING_HISTORY = [
  '3',
  '6',
  '12',
  '36',
];
export const FILTER_DATE_RANGE_LIST_FOR_PAYMENT_HISTORY = [
  '3',
  '6',
  '12',
  '18',
];
export const FILTER_DATE_RANGE_LIST_FOR_GOV_PAYMENT_HISTORY_TMG = [
  '3',
  '6',
  '12',
  '24',
];
export const FILTER_DATE_RANGE_LIST_FOR_GOV_BILLING_HISTORY_TMG = [
  '3',
  '6',
  '12',
  '24',
];

export const FILTER_DATE_RANGE_LIST_FOR_GOV_BILLING_HISTORY_VMS = [
  '3',
  '6',
  '12',
  '18',
];
export const PAYMENT = 'payment';
export const BILLING = 'billing';
export const INITIAL_FILTER_COUNT = 0;
export const VIEW_ALL = 'View-all';

export enum FUTURE_TERMED_BILL_TYPES {
  EXPIRING_POLICY = 'Expiring Policy',
  EXPIRED_POLICY = 'Expired Policy',
}

export enum EXCHANGE_INDICATOR_TYPE {
  ON_EXCHANGE = 'On-Exchange',
  OFF_EXCHANGE = 'Off-Exchange',
}

export const CA_TERMED_BILL_TYPE = 'CATermed';

export enum BILLING_STATUS {
  PAID_IN_FULL = 'Paid In full',
  UNPAID = 'Unpaid',
  PARTIALLY_PAID = 'Partially Paid',
}

export enum BILLING_STATUS_BG_COLOR {
  YELLOW = 'yellow-1',
  GREEN = 'green-1',
  RED = 'red-1',
}

export enum BILLING_STATUS_ICONS {
  CHECK = 'check',
}
